import { Product } from '@/fo/ui/product/tile/medium';
import { MappedProduct } from '@/fo/util/map-product-data';

export const mapProductTileMedium = (product: MappedProduct): Product => ({
  id: product.sku,
  image: product.thumbnail?.src || '',
  alt: product.thumbnail?.alt || product.name,
  link: product.link,
  stock: product.stockStatus,
  title: product.name,
  subtitle: product.nameEng,
  labels: product.labels,
  prices: {
    price: product.basePrice,
    oldPrice: product.finalPrice
  },
  currency: product.currency
});
